import type { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import type { Lci3DimensionTableData } from '@features/lci-report/models/lci3-types';
import { TOP_BOTTOM_NAMES } from '../slides/overview-slide-interface';
import type { Subdimension } from '@features/reports/subdomains/visitation';
import { sortNullable } from '@utils/arrays';

const SUBDIMENSIONS_PER_PAGE = 8;

const topBottomNameFromIndex = (index: number, total: number) => {
  if (index < SUBDIMENSIONS_PER_PAGE) return TOP_BOTTOM_NAMES[0];
  if (index >= total - SUBDIMENSIONS_PER_PAGE) return TOP_BOTTOM_NAMES[1];
  return null;
};

export const buildDimensionTableData = (
  selectedDimensionStats: Subdimension[] | undefined
): Lci3DimensionTableData => {
  const sortedDimensionStats = selectedDimensionStats?.sort((a, b) =>
    sortNullable(
      a.visitMetrics.optimizationIndex,
      b.visitMetrics.optimizationIndex
    )
  );
  const totalDimensions = sortedDimensionStats?.length ?? 0;
  const dimensionTableData =
    selectedDimensionStats?.reduce<Record<string, Lci3Report['subdimensions']>>(
      (accumulator, dimensionStat, index) => {
        const dimensionName = dimensionStat.name;
        const topBottomName = topBottomNameFromIndex(index, totalDimensions);
        const assignValuesByName = (name: string) => {
          accumulator[name] ??= [];
          accumulator[name] = [...accumulator[name], dimensionStat];
        };
        assignValuesByName(dimensionName);

        if (topBottomName) {
          assignValuesByName(topBottomName);
        }

        return accumulator;
      },
      {}
    ) ?? {};

  return dimensionTableData;
};
